<template>
  <div class="oneStudentReport">
    <div class="title">
      <span class="btn" @click="goBack"><i class="icon_back"></i> 返回</span>
      学生作业报告详情
    </div>
    <div class="oneBox">
    <div class="oneBoxL" v-if='leftBar'>
      <ul>
        <li :class="{active: index == (ranking - 1)}" v-for="(item, index) in studentAllList" @click="toggleStudent(item)">
          <span class="fl">{{item.userName}}</span>
          <span class="fr smallF">{{item.totalScore}}</span>
        </li>
      </ul>
    </div>
    <div class="oneBoxR" :class="{oneRwidth: !leftBar}">
      <span class="leftBtn" @click="hideLeftBar">
        <i class="iconBtn iconBtnLeft" :class="{iconBtnRight: !leftBar}"></i>
      </span>
       <nav class="oneNav">
         <span class="oneName">{{userName}}</span>
          <span class="wtUp" @click="lastStudent">
            <i></i>
            <span>上一个</span>
          </span>
         <span class="wtNext" @click="nextStudent">   
          <i></i>
          <span>下一个</span>
        </span>
       </nav>
       <div class="dataBox">
        <div class="basicInfo">
          <span class="tip">基本情况</span>
          <table>
            <tr>
              <th>成绩排名</th>
              <th>
                得分
                <el-popover placement="bottom" width="200" trigger="hover" content="一段时间内，学生平均得分，换算成百分制。">
                    <i class="iconQMark" slot="reference"></i>
                </el-popover>
              </th>
              <th>班级平均分
                <el-popover placement="bottom" width="200" trigger="hover" content="一段时间内，学生平均得分，换算成百分制。">
                    <i class="iconQMark" slot="reference"></i>
                </el-popover>
              </th>
              <th>提交率</th>
            </tr>
            <tr>
              <td>{{workReport.ranking}}</td>
              <td>{{workReport.avgScore}}</td>
              <td>{{workReport.classAvgRelativeScore}}</td>
              <td class="equalAvg" :class="{'overAvg': workReport.submitRate > workReport.classSubmitRate, 'lowAvg': workReport.submitRate < workReport.classSubmitRate}">{{workReport.submitRate}}%</td>
            </tr>
          </table>
        </div>
        <echartLine :echartData="echartLineData" :userName="userName" @setresourceType="setresourceType"></echartLine>
        <echartPie :echartData="echartPieData"></echartPie>
        <!-- 作业报告 详情列表 -->
        <workInfo :reportDetail="reportDetail" :workReport="workReport" :timeData="timeData" @setPage="setPage"></workInfo>
       </div>
    </div>
    </div>
  </div>
</template>
<script>
import fetch from "./../fetch";
import echartLine from "./../components/oneReport/echartLine.vue";
import echartPie from "./../components/oneReport/echartPie.vue";
import workInfo from "./../components/oneReport/scoreTable.vue";
export default {
  data() {
    return {
      leftBar: true,
      routerParams: {},
      studentAllList: [],
      echartLineData: [],
      echartPieData: [],
      basicData: {},
      reportDetail: [],
      workReport: {},
      ranking: 0,
      userName: '',
      page: 1,
      timeData: {}
    };
  },
  components: {
    echartLine,
    echartPie,
    workInfo
  },
  created() {
    this.$nextTick(() => {
      this.urlData =  this.$route.query
      this.timeData = {
        startDate: this.urlData.startDate,
        endDate: this.urlData.endDate,
      }
      this.ranking = this.urlData.index
      this.getStudentList()
      this.getEchartData()
      this.getEchartPieData()
      this.getReportDetail()
    });
  },
  methods: {
    getStudentList () {
      let listData = this.urlData
       let params = {
        classId: listData.classId,
        startDate: listData.startDate,
        endDate: listData.endDate
      }
      fetch.getStudentWorkReport(params).then(res => {
        if (!res) {
          return false
        }
        this.studentAllList = res.data
        this.userName = this.studentAllList[this.ranking - 1].userName
      })
    },
    getEchartData (resourceT) {
      let params = this.urlData
      let paramsData = {
        classId: params.classId,
        userId: params.userId,
        resourceType: resourceT || '',
        startDate: params.startDate,
        endDate: params.endDate
      }
      fetch.getScoreRecord(paramsData).then(res => {
        if (!res) {
          return false
        }
        this.echartLineData = res.data
      })
    },
    getEchartPieData () {
      let params = {
        classId: this.urlData.classId,
        userId: this.urlData.userId,
        startDate: this.urlData.startDate,
        endDate: this.urlData.endDate
      }
      fetch.getStudentWorkReportInfo(params).then(res => {
        if (!res) {
          return false
        }
        this.basicData = res.data
        this.workReport = this.basicData.workReport
        this.echartPieData = this.basicData.statistics
      })
    },
    getReportDetail () {
      let paramsData = this.urlData
      paramsData.page = this.page
      paramsData.pageSize = 5
      fetch.getStudentReportDetail(paramsData).then(res => {
        if (!res) {
          return false
        }
        this.reportDetail = res.data
      })
    },
    setresourceType(i) {
      let resourceArr = ['', 'a7527f97-14e6-44ef-bf73-3039033f128e', '992a5055-e9d0-453f-ab40-666b4d7030bb', 'fcfd6131-cdb6-4eb8-9cb9-031f710a8f15', 'c458a8d4-e3ca-403c-b6b2-ae166e955590', '3ac07125-31ac-11e5-a511-782bcb066f05']
      console.log(i, resourceArr[i])
      this.getEchartData(resourceArr[i])
    },
    setPage(val) {
      this.page = val
      this.getReportDetail()
    },
    lastStudent () {
      let index = this.ranking * 1
      if (index <= 0) {
        return false
      }
      let userId = this.studentAllList[index-2].userId
      this.urlData.userId = userId
      this.userName = this.studentAllList[index-2].userName
      this.getEchartData()
      this.getEchartPieData()
      this.getReportDetail()
      this.ranking -=1
    },
    nextStudent () {
      let index = this.ranking * 1
      let listLen = this.studentAllList.length
      if (index >= listLen) {
        return false
      }
      let userId = this.studentAllList[index].userId
      this.urlData.userId = userId
      this.userName = this.studentAllList[index].userName
      this.getEchartData()
      this.getEchartPieData()
      this.getReportDetail()
      this.ranking += 1
    },
    toggleStudent (data) {
      let index = data.ranking
      this.ranking = index
      let userId = this.studentAllList[index - 1].userId
      this.urlData.userId = userId
      this.userName = this.studentAllList[index-1].userName
      this.getEchartData()
      this.getEchartPieData()
      this.getReportDetail()
      // this.ranking += 1
    },
    hideLeftBar () {
     this.leftBar = !this.leftBar
    },
    goBack () {
      let params = {
        classId: this.urlData.classId,
        startDate: this.urlData.startDate,
        endDate: this.urlData.endDate
      }
      this.$router.push({ name: "studentReport", query: params });
    }
  }
};
</script>




// WEBPACK FOOTER //
// oneStudentReport.vue?ccaf5d46